import { IntrinsicNodeStyleProps, IntrinsicTextNodeStyleProps, hexColor } from "@lightningtv/solid";
// @ts-ignore
import theme from "theme";
// Augment existing intrinsic style prop interfaces to include our own
// app-specific states
declare module "@lightningtv/solid" {
  interface IntrinsicNodeStyleProps {
    // TODO: Refactor states to use a $ prefix
    active?: IntrinsicNodeStyleProps;
    disabled?: IntrinsicNodeStyleProps;
  }
  interface IntrinsicTextNodeStyleProps {
    // TODO: Refactor states to use a $ prefix
    active?: IntrinsicTextNodeStyleProps;
    disabled?: IntrinsicTextNodeStyleProps;
  }
}
export default {
  Page: {
    width: 1920,
    height: 1080,
  },
  headlineText: {
    width: 1200,
    height: 240,
    x: 360,
    // lineHeight: 170, // TODO: Add back when lineHeight is supported
    y: 455,
    contain: "both",
    fontSize: 66,
    textAlign: "center",
  } satisfies IntrinsicTextNodeStyleProps,
  LicenseButton: {
    scale: 1,
    zIndex: 2,
    color: hexColor("#484e55"),
    transition: { scale: { duration: 250, easing: "ease-in-out" } },
    focus: { scale: 1, color: hexColor("#2563eb") },
    // justifyContent: "center",
    // alignItems: "center",
    // display: "flex",
    width: 750,
    height: 130,
    borderRadius: 8,
  },

  skipButton: {
    width: 200,
    height: 60,
    zIndex: 2,
    color: hexColor("#484e55"),
    focus: { color: hexColor("#2563eb") },
    borderRadius: 10,
    y: 630,
    x: 240,
  },
  playButton: {
    scale: 1,
    width: 60,
    height: 60,
    zIndex: 2,
    color: hexColor("#484e55"),
    transition: { scale: { duration: 250, easing: "ease-in-out" } },
    focus: { scale: 1, color: hexColor("#2563eb") },
    borderRadius: 30,
  },
  trackButton: {
    scale: 1,
    width: 50,
    height: 50,
    zIndex: 2,
    color: hexColor("#484e55"),
    transition: { scale: { duration: 250, easing: "ease-in-out" } },
    focus: { scale: 1, color: hexColor("#2563eb") },
    borderRadius: 30,
  },
  progressBar: {
    scale: 1,
    width: 1200,
    height: 15,
    zIndex: 2,
    color: hexColor("#484e55"),
    transition: { scale: { duration: 250, easing: "ease-in-out" } },
    focus: { scale: 1, color: hexColor("#2563eb") },
    borderRadius: 5,
  },
  moviesBackgroundItem: {
    width: 260,
    height: 407,
    borderRadius: 10,
    color: "#484e55",
    alpha: 0.9,

    scale: 1,
    focus: {
      color: "#128DD3",
      scale: 1,

      alpha: 1,
    },
  },
  textchannels: {
    fontSize: 22,
  },
  containerText: {
    scale: 1,
    width: 510,
    height: 80,
    zIndex: 2,
    color: hexColor("#484e55"),
    transition: { scale: { duration: 250, easing: "ease-in-out" } },
    focus: { scale: 1, color: hexColor("#128DD3") },
    borderRadius: 15,
  },
  buttonKey: {
    scale: 1,
    width: 80,
    height: 80,
    zIndex: 2,
    color: hexColor("#484e55"),
    transition: { scale: { duration: 250, easing: "ease-in-out" } },
    focus: { scale: 1, color: hexColor("#128DD3") },
    borderRadius: 8,
  },
  buttonKeyPin: {
    scale: 1,
    width: 120,
    height: 80,
    zIndex: 2,
    color: hexColor("#484e55"),
    transition: { scale: { duration: 250, easing: "ease-in-out" } },
    focus: { scale: 1, color: hexColor("#2563eb") },
    borderRadius: 8,
  },
  privacyMode: {
    scale: 1,
    width: 350,
    height: 80,
    zIndex: 2,
    color: hexColor("#484e55"),
    transition: { scale: { duration: 250, easing: "ease-in-out" } },
    focus: { scale: 1, color: hexColor("#128DD3") },
    borderRadius: 8,
  },
  line: {
    height: 1,
    width: 1780,
    color: hexColor("#808080"),
    y: 880,
    x: 50,
  },
  space: {
    scale: 1,
    width: 250,
    height: 80,
    zIndex: 2,
    color: hexColor("#484e55"),
    transition: { scale: { duration: 250, easing: "ease-in-out" } },
    focus: { scale: 1, color: hexColor("#128DD3") },
    borderRadius: 8,
  },
  TrashButton: {
    scale: 1,
    zIndex: 2,
    transition: { scale: { duration: 250, easing: "ease-in-out" } },
    focus: { scale: 1, color: hexColor("#128DD3") },
  },
  searchButton: {
    width: 100,
    height: 100,
    color: "#484e55",
    borderRadius: 50,

    focus: {
      color: "#128DD3",
    },
  },
  headlineSubText: {
    width: 960,
    height: 170,
    // lineHeight: 170, // TODO: Add back when lineHeight is supported
    x: 530,
    y: 655,
    contain: "both",
    fontSize: 48,
    textAlign: "center",
  } satisfies IntrinsicTextNodeStyleProps,
  itemsContainer: {
    width: theme.layout.screenW,
    height: 600,
    y: 530,
    x: 0,
    zIndex: 2,
  },
  itemsContainerChannelMenu: {
    width: theme.layout.screenW,
    height: 1050,
    y: 0,
    x: 0,
    zIndex: 2,
  },
  favoritesButton: {
    scale: 1,
    zIndex: 2,
    color: "0x4F7F4F",
    transition: { scale: { duration: 250, easing: "ease-in-out" } },
    focus: { scale: 1.03, color: hexColor("0x467ffa") },
    justifyContent: "center", // Centers horizontally
    alignItems: "center", // Centers vertically
    display: "flex", // Ensures that flexbox properties are applied
  },
  Thumbnail: {
    borderRadius: 16,
    width: 185,
    height: 278,
    scale: 1,
    zIndex: 2,
    transition: { scale: { duration: 250, easing: "ease-in-out" } },
    border: { width: 0, color: 0x00000000 },
    focus: { scale: 1.1, border: { color: 0xffffff66, width: 8 } },
  },
  ThumbnailChannel: {
    borderRadius: 16,
    width: 885,
    height: 115,
    scale: 1,
    zIndex: 2,
    color: 0x4f7f4f,
    transition: { scale: { duration: 250, easing: "ease-in-out" } },
    border: { width: 0, color: 0x00000000 },
    focus: { scale: 1.03, color: "0x467ffa" },
  },
  ThumbnailMovie: {
    borderRadius: 16,
    width: 985,
    height: 225,
    scale: 1,
    zIndex: 2,
    color: 0x304090,
    transition: { scale: { duration: 250, easing: "ease-in-out" } },
    border: { width: 0, color: 0x00000000 },
    focus: { scale: 1.03, color: "0x467ffa" },
  },
  ThumbnailRecomandation: {
    borderRadius: 16,
    width: 185,
    height: 278,
    scale: 1,
    zIndex: 2,
    transition: { scale: { duration: 250, easing: "ease-in-out" } },
    border: { width: 0, color: 0x00000000 },
    focus: { scale: 1.1, border: { color: "#128DD3", width: 8 } },
  },
  imageBack: {
    // color: "#fff",
    // focus: { color: hexColor("#73737399") },
  },
  ThumbnailChannelList: {
    borderRadius: 8,
    width: 500,
    height: 120,
    scale: 1,
    zIndex: 2,
    transition: { scale: { duration: 250, easing: "ease-in-out" } },
    focus: { color: hexColor("#128DD3"), textColor: hexColor("#FFFFFF") },
    color: hexColor("#484e5599"),
    // alignItmes: "center",
  },
  FocusRing: {
    borderRadius: 16,
    width: 194,
    height: 286,
    y: -5,
    x: -5,
    zIndex: -1,
  },
  FPS: {
    color: 0x000000ff,
    height: 42,
    width: 140,
    x: 20,
    y: 20,
    zIndex: 100,
  } as const,
  FPSLabel: {
    x: 10,
    y: 0,
    fontSize: 36,
    textColor: hexColor("#FFFFFF"),
  },
  FPSValue: {
    x: 90,
    y: 0,
    fontSize: 36,
    textColor: hexColor("#FFFFFF"),
  },
  showHeadline: { x: 70, y: 20 },
  headlineBlur: {
    width: 1920,
    height: 150,
    x: 0,
    y: 0,
    zIndex: 14,
    alpha: 0.9,
    color: hexColor("#000000"),
  },
  RowTitle: {
    height: 60,
    width: 300,
    marginBottom: -40,
    fontSize: 36,
    color: hexColor("#F0F0F0"),
    zIndex: 2,
  } satisfies IntrinsicTextNodeStyleProps,
  Row: {
    display: "flex",
    justifyContent: "spaceBetween",
    height: 65,
  },
  RowChannel: {
    display: "flex",
    justifyContent: "spaceBetween",
    margin: 10,
    height: 130,
    width: 100,
  },
  RowSeries: {
    display: "flex",
    justifyContent: "spaceBetween",
    height: 265,
  },
  RowMovie: {
    display: "flex",
    justifyContent: "spaceBetween",
    height: 170,
  },
  Column: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flexStart",
    gap: 64,
    width: theme.layout.screenW - 2 * theme.layout.marginX,
    height: 20,
    x: theme.layout.marginX + theme.layout.gutterX,
    y: 48,
    transition: { y: { duration: 250, easing: "ease-in-out" } },
    zIndex: 2,
  },
  Rect: {
    width: 250,
    height: 100,
    y: 10,
    x: 300,
    color: hexColor("#0000FF"),
  },
  peopleBio: {
    ...theme.typography.body1,
    fontFamily: "Ubuntu",
    fontWeight: "normal",
    contain: "both",
    width: 780,
    height: 340,
  } satisfies IntrinsicTextNodeStyleProps,
} as const;
const Button = {
  width: 120,
  height: 40,
  color: hexColor("#000000"),
  borderRadius: 8,
  border: { width: 2, color: hexColor("#3333FF") },
  scale: 1,
  focus: {
    scale: 1.1,
    border: { width: 5, color: hexColor("#333333") },
  },
  transition: { scale: true, color: true },
} satisfies IntrinsicNodeStyleProps;
const TopBar = {
  color: hexColor("#00A699"),
  height: 8,
  y: 2,
  x: -4,
  width: Button.width + 8,
} satisfies IntrinsicNodeStyleProps;
const ButtonText = {
  fontSize: 12,
  y: 12,
  // lineHeight: Button.height, // TODO: Add back when lineHeight is supported
  contain: "width",
  textAlign: "center",
  color: hexColor("#F6F6F9"),
  height: Button.height,
  width: Button.width,
} satisfies IntrinsicTextNodeStyleProps;
export const buttonStyles = {
  container: Button,
  topBar: TopBar,
  text: ButtonText,
} satisfies Record<string, IntrinsicTextNodeStyleProps>;
export const MaterialButton = {
  width: 386,
  height: 136,
  color: hexColor("#715CAB"),
  focus: {
    color: hexColor("#5A39A2"),
  },
  disabled: {
    color: hexColor("#291D43"),
  },
} satisfies IntrinsicNodeStyleProps;
export const MaterialButtonText = {
  fontSize: 32,
  contain: "width",
  textAlign: "center",
  mountY: -0.35,
  color: hexColor("#FFFFFF"),
  height: MaterialButton.height,
  width: MaterialButton.width,
  // lineHeight: MaterialButton.height, // TODO: Add back when lineHeight is supported
  focus: {
    fontSize: 40,
  },
  disabled: {
    color: hexColor("#909090"),
  },
} satisfies IntrinsicTextNodeStyleProps;
